const BannerData = [
    {
        id: 1,
        title: "Biofeedback&Neurofeedback",
        heading: 'to Become a Better Human',
        cover: require("../../Assets/Banner/banner2.jpg"),
    },
    
    {
        id: 2,
        title: 'NeurotrackerX',
        heading: 'World leader in Biofeedback,',
        cover: require("../../Assets/Banner/neurotracker x.png"),
    },
    {
        id: 3,
        title: 'Qualisys',
        heading: 'OVER 10, 000 PRODUCTS & EQUIPMENT OF MINIMALLY ',
        cover: require("../../Assets/Banner/Qualisys.png"),
    },
    {
        id: 4,
        title: 'Bertec',
        heading: 'OVER 10, 000 PRODUCTS & EQUIPMENT OF MINIMALLY ',
        cover: require("../../Assets/Banner/bertecbanner.jpg"),
    },
    {
        id: 5,
        title: 'Sports Vision Technology (SVT)',
        heading: 'OVER 10, 000 PRODUCTS & EQUIPMENT OF MINIMALLY ',
        cover: require("../../Assets/Banner/Trigno Avanti Sensor Superior EMG + IMU Technology.gif"),
    },
]

export default BannerData;